import { render, staticRenderFns } from "./updata-site-size.vue?vue&type=template&id=378b67fc&scoped=true"
import script from "./updata-site-size.vue?vue&type=script&lang=ts"
export * from "./updata-site-size.vue?vue&type=script&lang=ts"
import style0 from "./updata-site-size.vue?vue&type=style&index=0&id=378b67fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378b67fc",
  null
  
)

export default component.exports